var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"bg md:w-4/5 md:absolute",attrs:{"src":require("@/assets/bild.jpg")}}),_c('EvaLinker',{})],1)}
var staticRenderFns = []

export { render, staticRenderFns }